export default {
  // ============Страница "Сотрудники"============
  getEmployees(state, getters) {
    return state.employees;
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingZgiSystemData(state, getters) {
    return state.reportsSellingZgi &&
      state.reportsSellingZgi.data &&
      state.reportsSellingZgi.data.length > 0
      ? state.reportsSellingZgi.data
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersFromDealersData(state, getters) {
    return state.reportsOrdersFromDealers && state.reportsOrdersFromDealers.length > 0
      ? state.reportsOrdersFromDealers
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersFromDealersHeader(state, getters) {
    return state.reportsOrdersFromDealersHeaders && state.reportsOrdersFromDealersHeaders.length > 0
      ? state.reportsOrdersFromDealersHeaders
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersFromDealersTotal(state, getters) {
    return state.reportsOrdersFromDealersTotal && state.reportsOrdersFromDealersTotal.length > 0
      ? state.reportsOrdersFromDealersTotal
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersToSupplierData(state, getters) {
    return state.reportsOrdersToSupplier ? state.reportsOrdersToSupplier : null;
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersToSupplierHeaders(state, getters) {
    return state.reportsOrdersToSupplierHeaders && state.reportsOrdersToSupplierHeaders.length > 0
      ? state.reportsOrdersToSupplierHeaders
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersRetailData(state, getters) {
    return state.reportsOrdersRetail ? state.reportsOrdersRetail : null;
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersRetailHeaders(state, getters) {
    return state.reportsOrdersRetailHeaders && state.reportsOrdersRetailHeaders.length > 0
      ? state.reportsOrdersRetailHeaders
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportOrdersRetailTotal(state, getters) {
    return state.reportsOrdersRetailTotal && state.reportsOrdersRetailTotal.length > 0
      ? state.reportsOrdersRetailTotal
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingZgiTotalData(state, getters) {
    return state.reportsSellingZgi && state.reportsSellingZgi.total
      ? state.reportsSellingZgi.total
      : null;
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingCutSystemData(state, getters) {
    return state.reportsSellingCut &&
      state.reportsSellingCut.data &&
      state.reportsSellingCut.data.length > 0
      ? state.reportsSellingCut.data
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingCutTotalData(state, getters) {
    return state.reportsSellingCut && state.reportsSellingCut.total
      ? state.reportsSellingCut.total
      : null;
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingOptSystemData(state, getters) {
    return state.reportsSellingOpt &&
      state.reportsSellingOpt.data &&
      state.reportsSellingOpt.data.length > 0
      ? state.reportsSellingOpt.data
      : [];
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {*|*[]}
   */
  getReportSellingOptTotalData(state, getters) {
    return state.reportsSellingOpt && state.reportsSellingOpt.total
      ? state.reportsSellingOpt.total
      : null;
  },

  getFilteredEmployees(state, getters) {
    if (!getters.isEmployees) {
      return [];
    }

    let result = getters.getEmployees;

    const sortMap = getters.getSortMap['employees'];

    for (let key in sortMap) {
      if (key === 'name') {
        result.sort((first, second) => {
          if (first[key] > second[key]) {
            return sortMap[key] === 'asc' ? 1 : -1;
          }
          if (first[key] < second[key]) {
            return sortMap[key] === 'asc' ? -1 : 1;
          }
          return 0;
        });
      }
    }

    return result.filter(({ is_deleted }) => is_deleted !== 1);
  },

  isEmployees(state, getters) {
    const employees = getters.getEmployees;
    return employees && employees.length;
  },

  getSelectedEmployee(state, getters) {
    return state.selectedEmployee;
  },

  // ============Страница "Дилеры"============
  getDealers(state, getters) {
    return state.dealers;
  },

  getSortMap(state, getters) {
    return state.sortMap;
  },
  // ============Страница "Розничные цены"============
  getMarkups(state, getters) {
    return state.markups;
  },

  getServicesDelivery(state) {
    const services = state.services || [];

    const find = services.find(el => el.name?.toLowerCase() === 'доставка');
    return find;
  },
};
